'use strict';

import React, { Component } from 'react';
import { isAgent } from '../utils'
class SystemMessage extends Component {
  constructor(props) {
    super(props);
  }

  getMessageByType(msg) {
    let isAgentTrue = isAgent(this.props.message.nick);
    let display_name = this.props.message.display_name;
    display_name = display_name.replace('Visitor','Besucher')
    switch (msg.type) {
      case 'chat.memberjoin':
        if(this.props.message.display_name === 'BOT') return ''
        else {
          if(isAgentTrue){
            return `${display_name} ist dem Chat beigetreten`;
          }
          else{
            return '';
          }
        }
      case 'chat.memberleave':
        if(document.getElementById('msgWrapper').lastChild){
          let prevMsg = document.getElementById('msgWrapper').lastChild;
         if(prevMsg.classList.contains('system-msg-container')){
          if(prevMsg.previousSibling){
            let currNode = prevMsg.previousSibling;
  
            while(currNode && currNode.classList.contains('system-msg-container')){
              currNode = currNode.previousSibling;
            }
            if(currNode && currNode.querySelector('.chat-options')){
              currNode.querySelector('.chat-options').style.display = 'none';
            }
          }
         }
        }
        if(isAgentTrue){
          if(this.props.message.display_name === 'BOT') return ''
          else
          return `${display_name} hat den Chat verlassen`;
        }else
          return '';

      case 'chat.rating':
        if (!this.props.message.new_rating) {
          return 'You have removed the chat rating';
        }
        else {
          let rating = convertToSentenceCase(this.props.message.new_rating);
          rating = rating.replace('Good','Gut').replace('Bad','Schlecht')
          return `Sie haben den Chat-Dienst als ${rating} bewertet`
        }
      default:
        return JSON.stringify(msg);
    }
  }

  render() {
    return (
      <div className="system-msg-container">
        <span className="system-msg">{this.getMessageByType(this.props.message)}</span>
      </div>
    );
  }
}

function convertToSentenceCase(str) {
  return str[0].toUpperCase() + str.slice(1);
}

SystemMessage.displayName = 'SystemMessage';
SystemMessage.propTypes = {
  message: React.PropTypes.object
};
SystemMessage.defaultProps = {
  message: {
    msg: ''
  }
};

export default SystemMessage;



// WEBPACK FOOTER //
// ./src/components/SystemMessage.js